import gql from 'graphql-tag';
import { get } from 'lodash';
import moment from 'moment-timezone';
import React from 'react';
import { Mutation } from 'react-apollo';
import { compose } from 'recompose';

import withCaseDealerResponseActions from '../withCaseDealerResponseActions';

const createMutationFor = (
  mutation,
  faacArgsMapper,
  mutationPropsMapper = () => ({}),
) => WrappedComponent => componentProps => (
  <Mutation mutation={mutation} {...mutationPropsMapper(componentProps)}>
    {(...args) => (
      <WrappedComponent {...componentProps} {...faacArgsMapper(...args)} />
    )}
  </Mutation>
);

const mapFAACArgsToProps = (mutationPropName, loadingPropName) => (
  mutate,
  { loading },
) => ({
  [mutationPropName]: (variables = {}) => mutate({ variables }),
  [loadingPropName]: !!loading,
});

const createCustomDealerGQL = gql`
  mutation compositions_CaseDealerSelectionPanel_createCustomDealer(
    $caseId: ID!
  ) {
    createCustomDealer(input: { caseId: $caseId, customDealer: {} }) {
      customDealer {
        id
      }
    }
  }
`;

const updateCustomDealerGQL = gql`
  mutation compositions_CaseDealerSelectionPanel_updateCustomDealer(
    $id: ID!
    $patch: CustomDealerAttrs!
  ) {
    updateCustomDealer(input: { id: $id, patch: $patch }) {
      customDealer {
        id
        mileageRange {
          id
          max
          min
        }
        name
      }
    }
  }
`;

export default compose(
  withCaseDealerResponseActions,
  createMutationFor(
    createCustomDealerGQL,
    mapFAACArgsToProps('createCustomDealer', 'isCreatingCustomDealer'),
    ({ caseId, createDealerResponse }) => ({
      onCompleted: data => {
        createDealerResponse({
          caseId,
          dealerId: get(data, 'createCustomDealer.customDealer.id'),
          dealerResponseAttrs: {
            responseTime: moment.tz().format(),
          },
          dealerType: 'CUSTOM_DEALER',
        });
      },
      skip: !caseId,
    }),
  ),
  createMutationFor(
    updateCustomDealerGQL,
    mapFAACArgsToProps('updateCustomDealer', 'isUpdatingCustomDealer'),
  ),
);



// WEBPACK FOOTER //
// ./src/compositions/CaseDealerSelectionPanel/withCustomDealerActions/index.js